import React from 'react'



import UsePayment from '../UsePayment'
import { useDispatch, useSelector } from 'react-redux';


import WidgetChooseCards from './WidgetChooseCard'
import WidgetNewCard from './WidgetNewCard'

import Loader from '../../../../../components/Loader';
import { useTranslation } from 'react-i18next';
import { cardToken, sendCardToken } from '../../../../../reducers/feed/feed.actions';
import CardLogos  from '../CardLogos';


const WidgetPayment = ({
  wizardState,
  handleGoBack,
  owner,
  user,
  handleChangeState,
  selectedService,
  updateCustomFieldsValue
}) => {
  const [shouldSave, setShouldSave] = React.useState(false)
  const [active, setActive] = React.useState()
  const [isNewCard, setIsNewCard] = React.useState()
  const [paymentError, setPaymentError] = React.useState()
  const [fullName, setFullname] = React.useState('')
  const dispatch = useDispatch();

  const { t, i18n } = useTranslation();
  const {
    submitPaymentInfo,
    shouldSubmit,
    errorCardHandler,
    initPaymentController,
    errors,
    loading,
    setLoading,paymentLoading,
    cardType, CardErrorHndler,
    errorCard, setErrorCard
  } = UsePayment()

  React.useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  React.useEffect(() => {
    errors && setPaymentError(false)
  }, [errors])


  // React.useEffect(() => {
  //   setIsNewCard(!paymentMethods.length)
  //   if (paymentMethods.length) setLoading(false)
  // }, [paymentMethods, setLoading])

  const onGoBack = () => {
    // if (isNewCard && paymentMethods.length) {
    //   setIsNewCard(false)
    //   setLoading(false)
    //   return
    // }
    // handleGoBack()
  }

  const handleCreateBooking = async ({ wizardState, pfToken }) => {
    try {
      setPaymentError(false)
      const { selectedDate, selectedTime } = wizardState
      const [hours, minutes] = selectedTime.time.split(':');

      const bookingDate = new Date(selectedDate)
      bookingDate.setHours(hours)
      bookingDate.setMinutes(minutes)
      bookingDate.valueOf()

      const scheduledTimestamp = bookingDate.valueOf();
      const currentTimestamp = new Date().valueOf();

      const [firstName, lastName] = fullName.split(' ')
      const paymentMethod = isNewCard ?
        {
          pfToken,
          storeCard: shouldSave,
          cardHolderInfo: {
            firstName,
            lastName,
            email: user.email
          }
        }
        :
        {
          creditCard: wizardState
        }

      // const data = await bookingService.createBooking({
      //   serviceId: selectedService.id,
      //   serviceName: selectedService.name,
      //   scheduledAt: scheduledTimestamp,
      //   duration: selectedService.duration,
      //   userId: user.id || user.uid,
      //   ownerId: owner.id,
      //   created_at: currentTimestamp,
      //   updated_at: currentTimestamp,
      //   status: 'true',
      //   paymentMethod,
      // })
      // return data
    } catch (err) {
      setPaymentError(err.response.data)
      throw err
    }
  }

  const handleSubmit = async () => {


    const data = await submitPaymentInfo()

    return data


    // try {
    //   setPaymentLoading(true)
    //   if (isNewCard) {
    //     const data = await submitPaymentInfo()
    //     if (!(data?.statusCode === '1')) return
    //   }
    //   await handleCreateBooking({ wizardState, pfToken })
    //   setPaymentLoading(false)
    //   await updateCustomFieldsValue()
    // } catch (error) {
    //   setPaymentLoading(false)
    // }
  }

  const handleAddCard = () => {
    setIsNewCard(true)
  }

  const shouldAllowSubmit = React.useMemo(() => {
    if (isNewCard) return shouldSubmit
    if (wizardState) return true
    return false
  }, [isNewCard, shouldSubmit, wizardState])


  return (
    <div className={
      `widget-payment-container ${loading && 'widget-payment-container-loading'}`
    }>
   
      {errorCardHandler()}
      <div className={paymentLoading && 'card-loader'}>
        <Loader isLoadin={paymentLoading} height={280} size={60} >

        </Loader>
      </div>
      <WidgetNewCard
        shouldSave={shouldSave}
        setShouldSave={setShouldSave}
        errors={errors}
        paymentError={paymentError}
        fullName={fullName}
        setFullname={setFullname}
        cardType={cardType}
        initPaymentController={initPaymentController}
      />


      {/* {!isNewCard && (
        <WidgetChooseCards
          handleChangeState={handleChangeState}
          handleAddCard={handleAddCard}
          active={active}
          setActive={setActive}
        />
      )} */}
      <div className='cancel-next-message '>

        <button
          onClick={handleSubmit}
          loading={paymentLoading}
          text={'Next'}
        >{t(`Add Card`)} </button>
      </div>

     
      <CardLogos/>
    </div>
  )
}
export default WidgetPayment
